/**
 * Retrieve the contents of the childupp properties file that
 * is available relative at `./childupp.properties.js`.
 * @return {string}
 */
function fetchChilduppProperties() {
    // Launch an XHR Request as a Promise.
    // We use XHR here instead of fetch because fetch doesn't allow
    // to perform request with `file://` protocol, which is what happens
    // when running in a cordova environment
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', './childupp.properties.js', true);
        xhr.onerror = () => {
            const err = new Error(`Could not fetch childupp.properties.js due to: ${xhr.statusText}`);
            reject(err);
        };
        xhr.onload = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200)
                    resolve(xhr.responseText);
                // For some reason, cordova returns status = 0 even when the req was ok
                else if (xhr.status === 0 && xhr.responseText)
                    resolve(xhr.responseText);
                // Treat any other case as an error
                else
                    xhr.onerror();
            }
        };
        xhr.send(null);
    });
}

/**
 * Retrieve the childupp propertiest file via {@link fetchChilduppProperties}
 * execute it as a script and extract its contents.
 *
 * @return {object}
 */
export default async function loadChilduppProperties() {
    const fileContents = await fetchChilduppProperties();

    const context = {};

    // DANGER ZONE: We are going to eval some code...
    (function () {
        if (__DEV__) {
            // On dev environment (eg: webpack server) the file fetched will
            // contain references to following variables (instead of them
            // being replaced by their actual values as happens on production),
            // so we need to assign values to said variables.
            const __CHILDUPP_ID = process.env['CHILDUPP_ID'];
            const __FIREBASE_CONF = {
                // This is a trimmed down version of the full firebase conf
                // object when on production
                messagingSenderId: process.env['FIREBASE_CONF_SENDER_ID'],
            };
            eval(fileContents);
        } else {
            eval(fileContents);
        }
    }.bind(context))()

    // Check if after eval-ing the code it contains what we expect
    const propertiesPropName = 'CHILDUPP_PROPERTIES';
    if (!context.hasOwnProperty(propertiesPropName))
        throw new Error(`Wrong childupp.properties.js file, no ${propertiesPropName} on the file`);
    return context[propertiesPropName];
}



// WEBPACK FOOTER //
// ./src/shared/childupp-properties/api.js